import React, { useState } from "react";
import ReviewSectionWithProduct from "../components/Shared/ReviewSectionWithProduct";
import FaqAndContactSection from "../components/Shared/FaqAndContactSection";
import { appstoreicon, googleplayicon } from "../assets";
import { Link } from "react-router-dom";
import PlayVideoCard from "../components/Shared/PlayVideoCard";
import { InfoMicro } from "../assets/SvgIcons";

const reviews = [
  {
    href: "https://www.trustpilot.com/reviews/dummy1",
    rating: 5,
    date: "November 1, 2024",
    review: "Great quality, exceeded expectations!",
    product: {
      name: "Dummy Watch 1",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 28, 2024",
    shippedFrom: "Country X",
    reviewer: {
      name: "John Doe",
      location: "Country X",
      initial: "JD",
      color: "blue",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy2",
    rating: 4,
    date: "November 2, 2024",
    review: "The product was good, but the delivery was delayed.",
    product: {
      name: "Dummy Watch 2",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 29, 2024",
    shippedFrom: "Country Y",
    reviewer: {
      name: "Jane Smith",
      location: "Country Y",
      initial: "JS",
      color: "red",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy3",
    rating: 3,
    date: "November 3, 2024",
    review: "The watch was fine, but customer support was not responsive.",
    product: {
      name: "Dummy Watch 3",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 30, 2024",
    shippedFrom: "Country Z",
    reviewer: {
      name: "Alex Johnson",
      location: "Country Z",
      initial: "AJ",
      color: "purple",
    },
  },
  {
    href: "https://www.trustpilot.com/reviews/dummy4",
    rating: 5,
    date: "November 4, 2024",
    review: "Amazing watch, and the service was top-notch.",
    product: {
      name: "Dummy Watch 4",
      productImage:
        "https://cdn.discordapp.com/attachments/920721313105080390/1305569818501578752/Group_8.png?ex=67338225&is=673230a5&hm=612b814462bf449f0e0519a5b4eacaa9a9432ed7187030ddcfccfca6159cee9f&",
    },
    receivedDate: "October 31, 2024",
    shippedFrom: "Country W",
    reviewer: {
      name: "Emily White",
      location: "Country W",
      initial: "EW",
      color: "orange",
    },
  },
];
const faqs = [
  {
    id: 224,
    question: "What is the Watch Collection?",
    answer:
      "The Watch Collection lets you manage and track all of your watches online. Simply enter each watch's details and, if you'd like, add your own photos. You'll then have access to historical price trends, as well as projections of your timepieces' future financial performance. You can also use the Watch Collection to follow other watches you are interested in.",
  },
  {
    id: 225,
    question: "Do I have to own a watch to add it to my Watch Collection?",
    answer:
      "No, you can also follow watches that you are simply interested in. To track a watch's performance, enter its reference number or brand, model, and condition and select the option 'I don't own this watch.'",
  },
  {
    id: 226,
    question: "How many watches can I add to my Watch Collection?",
    answer: "You may add an unlimited number of watches.",
  },
  {
    id: 227,
    question:
      "Why is there a watch in my Watch Collection that I didn't personally add?",
    answer:
      "As soon as you purchase a watch on WristLink, it is automatically added to your Watch Collection, allowing you to track its value over time.",
  },
  {
    id: 228,
    question: "Which estimated values are available in the Watch Collection?",
    answer:
      "You can view the estimated value and change in value of each individual watch, as well as your entire collection.",
  },
  {
    id: 229,
    question: "How often is the estimated value updated?",
    answer:
      "Estimated values are reassessed on a daily basis. However, price fluctuations are only visible across longer periods of time.",
  },
  {
    id: 231,
    question: "Can I save personal information in the Watch Collection?",
    answer: "Yes, you can add your own photos and notes to each watch.",
  },
  {
    id: 232,
    question: "Can I add rare timepieces to the Watch Collection?",
    answer:
      "Yes, you can add any watch to your Watch Collection so that it is complete. That being said, there may be little to no data available on rare watches. If the same model is added by other users and we have sufficient data, new information will be added to your Watch Collection automatically.",
  },
  {
    id: 350,
    question: "Why are Rolex watches so expensive?",
    answer:
      "It's very difficult to buy a Rolex from offline retailers. At the same time, demand is extremely high, which in turn drives prices upward. Rolex is renowned for their premium quality, high precision, and innovative designs. As a result, Rolex watches enjoy tremendous prestige and are often considered status symbols. What's more, Rolex models are highly likely to increase in value, which also contributes to the brand's appeal.",
  },
];
const referenceInfoData = [
  {
    title: "On the dial",
    imgUrl:
      "https://static.chrono24.com/images/default/private-seller/ref-id-dial.png",
  },
  {
    title: "In the watch's papers",
    imgUrl:
      "https://static.chrono24.com/images/default/private-seller/ref-id-papers.png",
  },
  {
    title: "On the case back",
    imgUrl:
      "https://static.chrono24.com/images/default/private-seller/ref-id-case-back.png",
  },
  {
    title: "On the lugs",
    imgUrl:
      "https://static.chrono24.com/images/default/private-seller/ref-id-lugs.png",
  },
];
const watchAppraisalFeatures = [
  {
    title: "100% free",
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/money-received.svg",
    description:
      "Find out the value of your watch for free. Simply enter the model and condition, and then submit.",
  },
  {
    title: "Expert appraisal with one click",
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/watch-appraisal.svg",
    description:
      "WristLink is the leading marketplace for luxury watches – we compare your watches with 500,000 listings from around the world.",
  },
  {
    title: "Obtain the Best Sales Prices",
    imgUrl:
      "https://static.chrono24.com/images/default/illustrations/sell-watch.svg",
    description:
      "We know the market prices and will give you a recommended price so that you can make the best possible sale.",
  },
];

const Valuation = () => {
  return (
    <>
      <HeroSection />
      <AppraisalInfoSection data={watchAppraisalFeatures} />
      <VideoSection />
      <BannerSection />
      <ReferenceInfoSection data={referenceInfoData} />
      <ReviewSectionWithProduct
        reviews={reviews}
        // sectionClassName={"bg-secondary text-white"}
        sectionClassName={"bg-[#F3F3F3] text-black"}
        navBtnStyle={{ color: "black" }}
        ctaBtnStyle={{ borderColor: "black" }}
        sectionTitle={"Over 800,000 satisfied watch buyers worldwide"}
        sectionSubTitle={
          "Wrist-Wurx dealers receive great ratings: 4.8 out of 5 "
        }
      />
      <FaqSection faqs={faqs} />
    </>
  );
};

export default Valuation;

const WatchForm = () => {
  const [isSubmitted, setIsSubmitted] = useState(false); // Track submission state
  const [formData, setFormData] = useState({
    model: "",
    condition: "",
    scopeOfDelivery: "",
  });
  const [error, setError] = useState(""); // Track global error message

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true); // Mark the form as submitted

    // Validate form fields
    if (!formData.model || !formData.condition || !formData.scopeOfDelivery) {
      setError("Please fill in all required fields before submitting.");
    } else {
      setError(""); // Clear error if form is valid
      // You can add form submission logic here (e.g., API call)
    }
  };

  return (
    <div className="text-black text-[14px] pb-10">
      {/* Product Search */}
      <div className="w-full mb-4">
        <div className="form-group">
          <div className="relative">
            <input
              id="productSearch"
              name="model"
              value={formData.model}
              placeholder="Reference number, brand, model..."
              required
              autoComplete="off"
              className="form-control p-3 border border-gray-300 rounded-md w-full"
              type="search"
              onChange={(e) =>
                setFormData({ ...formData, model: e.target.value })
              }
            />
            <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
              <i className="i-search text-muted text-gray-500"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-2 lg:flex-row md:flex-row sm:flex-col mb-2">
        {/* Condition Selection */}
        <div className="w-full md:w-1/2 lg:w-1/2 mb-4">
          <div className="form-group">
            <select
              id="condition"
              name="condition"
              value={formData.condition}
              required
              className="form-control p-3 border border-gray-300 rounded-md w-full"
              onChange={(e) =>
                setFormData({ ...formData, condition: e.target.value })
              }
            >
              <option disabled value="">
                Watch condition
              </option>
              <option value="Unworn">Unworn</option>
              <option value="Used">Pre-owned</option>
            </select>
          </div>
        </div>

        {/* Scope of Delivery Selection */}
        <div className="w-full md:w-1/2 lg:w-1/2 mb-4">
          <div className="form-group">
            <select
              id="scopeOfDelivery"
              name="scopeOfDelivery"
              value={formData.scopeOfDelivery}
              required
              className="form-control p-3 border border-gray-300 rounded-md w-full"
              onChange={(e) =>
                setFormData({ ...formData, scopeOfDelivery: e.target.value })
              }
            >
              <option disabled value="">
                Scope of delivery
              </option>
              <option value="WatchOnly">Watch only</option>
              <option value="WithBox">Watch with original box</option>
              <option value="WithPapers">Watch with original papers</option>
              <option value="WithBoxAndPapers">
                Watch with original box and original papers
              </option>
            </select>
          </div>
        </div>
      </div>

      {/* Global Error Message */}

      <span
        className={
          isSubmitted && error
            ? "opacity-1 text-red-500 text-sm flex gap-1 items-center"
            : "opacity-0 text-red-500 text-sm flex gap-1 items-center"
        }
      >
        {InfoMicro}
        {error}
      </span>

      {/* Submit Button */}
      <div className="w-full mt-2">
        <input
          id="calculateStats"
          className="w-full px-8 py-3 rounded bg-secondary text-white font-semibold"
          name="calculateStats"
          type="submit"
          value="Have it appraised for free"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

const HeroSection = () => {
  const imgUrl =
    "https://cdn.discordapp.com/attachments/920721313105080390/1305567631969095802/image.png?ex=6733801b&is=67322e9b&hm=c5bf17718c64f31c0426da5df426eafc26fe349a3433c6e0f02e4093a3394e33&";
  return (
    <section
      style={{
        backgroundImage: `url(${imgUrl})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className="text-white min-h-[480px]"
    >
      {/* DROP SHADOW DIV */}
      <div
        className="w-full "
        style={{
          background: "linear-gradient(to top, black, transparent)",
        }}
      >
        {/* MAIN CONTAINER DIV */}
        <div className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex lg:flex-row md:flex-col-reverse sm:flex-col-reverse  items-center gap-4">
          <div className="w-full my-auto flex flex-col items-center  ">
            <h1 className="lg:text-6xl md:text-4xl sm:text-3xl text-center font-medium">
              What Is Your Watch Worth?
            </h1>
            <h3 className="lg:text-3xl md:text-2xl sm:text-xl text-center font-normal mb-8">
              {" "}
              Have it appraised now and sell it for the best possible price.
            </h3>
            {/* CTA FORM */}
            <div className="lg:w-1/2 md:w-full sm:w-full">
              <WatchForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const AppraisalInfoSection = ({ data }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex flex-col gap-12">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl text-center font-semibold mb-0">
        The Benefits of Watch Appraisal on WristLink
      </h2>
      <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-3">
        {data?.map((infoSection, index) => {
          return (
            <div
              key={index}
              className={`w-full  justify-center items-center lg:gap-12 md:gap-6 sm:gap-6`}
            >
              <div className="w-1/3 mx-auto">
                <div
                  className="relative rounded-lg overflow-hidden"
                  style={{ paddingTop: "100%" }}
                >
                  <div
                    className="absolute inset-0"
                    style={{
                      backgroundImage: `url(${infoSection?.imgUrl})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  />
                </div>
              </div>

              <div className="p-4 mx-auto">
                <p className="lg:text-[18px] md:text-[16px] sm:text-[14px] font-semibold text-center mb-2">
                  {infoSection?.title}
                </p>
                <p className="lg:text-[14px] md:text-[12px] sm:text-[12px] text-center">
                  {infoSection?.description}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
const VideoSection = () => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 ">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl text-center font-semibold mb-0">
        Create Listings Quickly and Easily
      </h2>
      <h2 className="text-[12px] text-center mb-6">
        In this video, we'll show you how easy it is to create a free listing on
        WristLink.
      </h2>
      <PlayVideoCard
        videoUrl="https://www.youtube.com/"
        thumbnailUrl="https://cdn.discordapp.com/attachments/920721313105080390/1305573370745720973/Group_9.png?ex=67338573&is=673233f3&hm=49bc36497a55456276097e59c02289ecd287b88de11fbeb5ae6fe6206ef8473e&"
        // description="ROLEX explained in 3 minutes | Short on Time"
        playTime="3:35"
        videoCardClassName={"lg:w-7/12 md:w-10/12 sm:w-full"}
      />
    </section>
  );
};
const BannerSection = () => {
  const description =
    "Download the WristLink app now and add models to your Watch Collection using the Watch Scanner. Whether it's on your wrist, in a magazine article, or in a display case, all it takes is a single photo to add a new watch to your online collection.";
  const imgUrl =
    "https://cdn.discordapp.com/attachments/920721313105080390/1305567631969095802/image.png?ex=6733801b&is=67322e9b&hm=c5bf17718c64f31c0426da5df426eafc26fe349a3433c6e0f02e4093a3394e33&";
  return (
    <section
      style={{
        backgroundImage: `url(${imgUrl})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
      className=" max-w-[1200px] min-h-[470px] lg:mx-auto md:mx-4 sm:mx-2 rounded-lg "
    >
      <div
        style={{
          background: "linear-gradient(to right, black, transparent)",
        }}
        className="text-white lg:p-14 md:p-12 sm:p-10 rounded-lg grid lg:grid-cols-2 sm:grid-cols-1"
      >
        {/* BANNER CONTENT  */}
        <div className=" flex flex-col justify-between ">
          {/* BANNER MESSAGE */}
          <div className="my-auto">
            <h3 className="lg:text-2xl md:text-xl sm:text-lg font-medium ">
              Watch Scanner
            </h3>
            <h2 className="lg:text-3xl md:text-2xl sm:text-xl font-semibold mb-6">
              Build Your Collection With Photos
            </h2>

            <div className="mb-6">
              <span className="">{description}</span>
            </div>
          </div>
          {/* CTA */}
          <div className="">
            <span className="lg:text-[14px] md:text-[12px] sm:text-[10px]">
              {" "}
              Install the app to try it now:
            </span>
            <div className="flex gap-2 mt-2">
              <Link
                className="block mb-2"
                to="https://discover.chrono24.com/VuxF?af_xp=custom&pid=WristLink&c=footer&af_dp=WristLink-app://&utm_source=WristLink&utm_medium=onsite&utm_campaign=footer"
                target="_blank"
                aria-label="To the App Store"
              >
                <img
                  src={appstoreicon}
                  alt="App Store"
                  className="h-[40px] w-[135px]"
                />
              </Link>
              <Link
                to="https://discover.chrono24.com/VuxF?af_web_dp=https://play.google.com/store/apps/details?id=com.WristLink.mobile&af_xp=custom&pid=WristLink&c=footer&af_dp=WristLink-app://&utm_source=WristLink&utm_medium=onsite&utm_campaign=footer"
                target="_blank"
                aria-label="To Google Play"
              >
                <img
                  src={googleplayicon}
                  alt="Google Play"
                  className="h-[40px] w-[135px]"
                />
              </Link>
            </div>
          </div>
        </div>

        {/* BANNER IMAGE FOR LARGE DEVICE */}
        <div className="rounded-r-lg lg:block md:hidden sm:hidden min-h-[360px]" />
      </div>
    </section>
  );
};

const ReferenceInfoSection = ({ data }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 flex flex-col gap-12">
      <h2 className="lg:text-3xl md:text-2xl sm:text-xl text-center font-semibold mb-0">
        Where do I find my watch's reference number?
      </h2>
      <div className="grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 gap-3">
        {data?.map((infoSection, index) => {
          return (
            <div
              key={index}
              className={`w-full border rounded-lg justify-center items-center lg:gap-12 md:gap-6 sm:gap-6`}
            >
              <div
                className="relative rounded-lg overflow-hidden"
                style={{ paddingTop: "100%" }}
              >
                <div
                  className="absolute inset-0"
                  style={{
                    backgroundImage: `url(${infoSection?.imgUrl})`,
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                />
              </div>

              <p className="border-t px-2 py-4 text-center lg:text-[16px] md:text-[14px] sm:text-[12px]">
                {infoSection?.title}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const FaqSection = ({ faqs }) => {
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 ">
      <FaqAndContactSection faqs={faqs} />
    </section>
  );
};
